/* @ds-bundle: {"format":4,"namespace":"HOLLISDesignSystem_8fdab3","components":[{"name":"DoseCard","sourcePath":"components/cards/DoseCard.jsx"},{"name":"FamilyCard","sourcePath":"components/cards/FamilyCard.jsx"},{"name":"MetaCard","sourcePath":"components/cards/MetaCard.jsx"},{"name":"ProductCard","sourcePath":"components/cards/ProductCard.jsx"},{"name":"StatCard","sourcePath":"components/cards/StatCard.jsx"},{"name":"TipCard","sourcePath":"components/cards/TipCard.jsx"},{"name":"ValueCard","sourcePath":"components/cards/ValueCard.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Chip","sourcePath":"components/core/Chip.jsx"},{"name":"Eyebrow","sourcePath":"components/core/Eyebrow.jsx"},{"name":"StatBig","sourcePath":"components/data/StatBig.jsx"},{"name":"Timeline","sourcePath":"components/data/Timeline.jsx"},{"name":"IndicBanner","sourcePath":"components/feedback/IndicBanner.jsx"},{"name":"Footer","sourcePath":"components/layout/Footer.jsx"},{"name":"ReassuranceBar","sourcePath":"components/layout/ReassuranceBar.jsx"},{"name":"Accordion","sourcePath":"components/navigation/Accordion.jsx"},{"name":"NavBar","sourcePath":"components/navigation/NavBar.jsx"}],"sourceHashes":{"components/cards/DoseCard.jsx":"2cba63254ddd","components/cards/FamilyCard.jsx":"3f654eb4cf4a","components/cards/MetaCard.jsx":"d171f1cf12e5","components/cards/ProductCard.jsx":"ae54daf4a35b","components/cards/StatCard.jsx":"f11faa367b31","components/cards/TipCard.jsx":"6456e7a72f23","components/cards/ValueCard.jsx":"92d318083020","components/core/Button.jsx":"8fe3d2de1b5d","components/core/Chip.jsx":"70bdeadbeaeb","components/core/Eyebrow.jsx":"60469bdc2db8","components/data/StatBig.jsx":"15c8a0709b02","components/data/Timeline.jsx":"a9a84020e817","components/feedback/IndicBanner.jsx":"d8bd79f93c71","components/layout/Footer.jsx":"4e2ffb7999a1","components/layout/ReassuranceBar.jsx":"8dd00b722f39","components/navigation/Accordion.jsx":"4486497f597e","components/navigation/NavBar.jsx":"681f9e753820"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.HOLLISDesignSystem_8fdab3 = window.HOLLISDesignSystem_8fdab3 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/cards/DoseCard.jsx
try { (() => {
function DoseCard({
  moment,
  count = 1,
  when
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "dose-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "gel"
  }), /*#__PURE__*/React.createElement("p", {
    className: "moment"
  }, moment), /*#__PURE__*/React.createElement("p", {
    className: "pill-n"
  }, count, " ", /*#__PURE__*/React.createElement("small", null, "g\xE9lule", count > 1 ? 's' : '')), /*#__PURE__*/React.createElement("p", {
    className: "when"
  }, when));
}
Object.assign(__ds_scope, { DoseCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/DoseCard.jsx", error: String((e && e.message) || e) }); }

// components/cards/FamilyCard.jsx
try { (() => {
function FamilyCard({
  tone,
  name,
  count,
  items = []
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'family fam-' + tone
  }, /*#__PURE__*/React.createElement("div", {
    className: "family__head"
  }, /*#__PURE__*/React.createElement("h4", null, name), /*#__PURE__*/React.createElement("p", {
    className: "cnt"
  }, count)), /*#__PURE__*/React.createElement("ul", null, items.map((it, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, it.name), it.desc && /*#__PURE__*/React.createElement("em", null, it.desc))))));
}
Object.assign(__ds_scope, { FamilyCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/FamilyCard.jsx", error: String((e && e.message) || e) }); }

// components/cards/MetaCard.jsx
try { (() => {
function MetaCard({
  icon,
  label,
  children,
  navy = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'meta-card' + (navy ? ' meta-card--navy' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "ic"
  }, icon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "k"
  }, label), /*#__PURE__*/React.createElement("p", {
    className: "v"
  }, children)));
}
Object.assign(__ds_scope, { MetaCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/MetaCard.jsx", error: String((e && e.message) || e) }); }

// components/cards/ProductCard.jsx
try { (() => {
function ProductCard({
  banner,
  bannerTone = 'mat',
  rating,
  image,
  name,
  children,
  href = '#'
}) {
  return /*#__PURE__*/React.createElement("a", {
    className: "prod",
    href: href
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prod__banner ' + bannerTone
  }, "\u2726 ", banner), /*#__PURE__*/React.createElement("div", {
    className: "prod__media"
  }, rating && /*#__PURE__*/React.createElement("span", {
    className: "prod__rating"
  }, /*#__PURE__*/React.createElement("span", {
    className: "s"
  }, "\u2605"), " ", rating), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name
  })), /*#__PURE__*/React.createElement("div", {
    className: "prod__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prod__name"
  }, name), /*#__PURE__*/React.createElement("p", {
    className: "prod__desc"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "prod__foot"
  }, /*#__PURE__*/React.createElement("span", {
    className: "prod__pharma"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a3 3 0 0 0-3 3v1H7a2 2 0 0 0-2 2v3a5 5 0 0 0 5 5v3a2 2 0 0 0 4 0v-3a5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-2V5a3 3 0 0 0-3-3Z"
  })), " Formul\xE9 par une pharmacienne"))));
}
Object.assign(__ds_scope, { ProductCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/ProductCard.jsx", error: String((e && e.message) || e) }); }

// components/cards/StatCard.jsx
try { (() => {
function StatCard({
  tag,
  title,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "scard"
  }, /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, tag), /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, children));
}
Object.assign(__ds_scope, { StatCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/StatCard.jsx", error: String((e && e.message) || e) }); }

// components/cards/TipCard.jsx
try { (() => {
function TipCard({
  icon,
  num,
  title,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "tip"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ic"
  }, icon), num != null && /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, String(num).padStart(2, '0')), /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("p", null, children));
}
Object.assign(__ds_scope, { TipCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/TipCard.jsx", error: String((e && e.message) || e) }); }

// components/cards/ValueCard.jsx
try { (() => {
function ValueCard({
  icon,
  title,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "val"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ic ic--flat"
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: ""
  })), /*#__PURE__*/React.createElement("h5", null, title), /*#__PURE__*/React.createElement("p", null, children));
}
Object.assign(__ds_scope, { ValueCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/cards/ValueCard.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function Button({
  children,
  variant = 'coral',
  href,
  onClick,
  arrow = false,
  type = 'button',
  style
}) {
  const cls = 'btn btn-' + variant;
  const content = /*#__PURE__*/React.createElement(React.Fragment, null, children, arrow && /*#__PURE__*/React.createElement("span", {
    className: "arr"
  }, "\u2192"));
  if (href) return /*#__PURE__*/React.createElement("a", {
    href: href,
    className: cls,
    style: style
  }, content);
  return /*#__PURE__*/React.createElement("button", {
    type: type,
    className: cls,
    onClick: onClick,
    style: style
  }, content);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Chip.jsx
try { (() => {
function Chip({
  children,
  tone = 'nausees'
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: 'chip ' + tone
  }, children);
}
Object.assign(__ds_scope, { Chip });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Chip.jsx", error: String((e && e.message) || e) }); }

// components/core/Eyebrow.jsx
try { (() => {
function Eyebrow({
  children,
  style
}) {
  return /*#__PURE__*/React.createElement("p", {
    className: "eyebrow",
    style: style
  }, children);
}
Object.assign(__ds_scope, { Eyebrow });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Eyebrow.jsx", error: String((e && e.message) || e) }); }

// components/data/StatBig.jsx
try { (() => {
function StatBig({
  value,
  unit,
  children
}) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "stat-big"
  }, value, unit && /*#__PURE__*/React.createElement("span", {
    className: "u"
  }, unit)), /*#__PURE__*/React.createElement("p", {
    className: "stat-cap"
  }, children));
}
Object.assign(__ds_scope, { StatBig });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/StatBig.jsx", error: String((e && e.message) || e) }); }

// components/data/Timeline.jsx
try { (() => {
function Timeline({
  steps = []
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "timeline"
  }, steps.map((s, i) => /*#__PURE__*/React.createElement("div", {
    className: "tl",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("p", {
    className: "wk"
  }, s.when), /*#__PURE__*/React.createElement("p", {
    className: "ti"
  }, s.title), /*#__PURE__*/React.createElement("p", {
    className: "tx"
  }, s.text))));
}
Object.assign(__ds_scope, { Timeline });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/Timeline.jsx", error: String((e && e.message) || e) }); }

// components/feedback/IndicBanner.jsx
try { (() => {
function IndicBanner({
  icon,
  title,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "indic"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ic"
  }, icon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("p", null, children)));
}
Object.assign(__ds_scope, { IndicBanner });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/IndicBanner.jsx", error: String((e && e.message) || e) }); }

// components/layout/Footer.jsx
try { (() => {
function Footer({
  logo = 'assets/logo-hollis-footer.png',
  tagline,
  links = [],
  legal
}) {
  return /*#__PURE__*/React.createElement("footer", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__brand"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#top",
    "aria-label": "Hollis"
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "Hollis Laboratoire"
  })), tagline && /*#__PURE__*/React.createElement("p", null, tagline), /*#__PURE__*/React.createElement("div", {
    className: "footer__social"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://instagram.com/laboratoirehollis/",
    target: "_blank",
    rel: "noopener",
    "aria-label": "Instagram"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/laboratoirehollis/",
    target: "_blank",
    rel: "noopener",
    "aria-label": "Facebook"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9h2.5l.5-3H14V4.3c0-.9.3-1.5 1.6-1.5H17V.1C16.7 0 15.7 0 14.6 0 12.2 0 10.6 1.4 10.6 4v2H8v3h2.6v9H14V9Z"
  }))))), /*#__PURE__*/React.createElement("nav", {
    className: "footer__links"
  }, links.map((l, i) => /*#__PURE__*/React.createElement("a", {
    key: i,
    href: l.href
  }, l.label)))), legal && /*#__PURE__*/React.createElement("div", {
    className: "footer__legal"
  }, /*#__PURE__*/React.createElement("span", null, legal[0]), /*#__PURE__*/React.createElement("span", null, legal[1])));
}
Object.assign(__ds_scope, { Footer });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/layout/Footer.jsx", error: String((e && e.message) || e) }); }

// components/layout/ReassuranceBar.jsx
try { (() => {
function ReassuranceBar({
  items = []
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "reassure__inner"
  }, items.map((it, i) => /*#__PURE__*/React.createElement("div", {
    className: "reassure__item",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "ic ic--flat"
  }, /*#__PURE__*/React.createElement("img", {
    src: it.icon,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, it.title), /*#__PURE__*/React.createElement("small", null, it.subtitle)))));
}
Object.assign(__ds_scope, { ReassuranceBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/layout/ReassuranceBar.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Accordion.jsx
try { (() => {
const {
  useState
} = React;
function Accordion({
  items = []
}) {
  const [open, setOpen] = useState(0);
  return /*#__PURE__*/React.createElement("div", {
    className: "accordion"
  }, items.map((it, i) => /*#__PURE__*/React.createElement("div", {
    className: 'acc-item' + (open === i ? ' open' : ''),
    key: i
  }, /*#__PURE__*/React.createElement("button", {
    className: "acc-head",
    "aria-expanded": open === i,
    onClick: () => setOpen(open === i ? -1 : i)
  }, /*#__PURE__*/React.createElement("span", {
    className: "nm"
  }, it.name, " ", it.reg && /*#__PURE__*/React.createElement("span", {
    className: "reg"
  }, it.reg)), it.chips, /*#__PURE__*/React.createElement("span", {
    className: "pm"
  })), /*#__PURE__*/React.createElement("div", {
    className: "acc-body",
    style: {
      maxHeight: open === i ? 400 : 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "acc-body__inner"
  }, it.text)))));
}
Object.assign(__ds_scope, { Accordion });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Accordion.jsx", error: String((e && e.message) || e) }); }

// components/navigation/NavBar.jsx
try { (() => {
const {
  useState
} = React;
function NavBar({
  logo = 'assets/logo-hollis.png',
  links = [],
  cta
}) {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: "nav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav__inner"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#top",
    className: "brand",
    "aria-label": "Hollis"
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "Hollis Laboratoire"
  })), /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: "nav__links"
  }, links.map((l, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("a", {
    href: l.href
  }, l.label))))), cta && /*#__PURE__*/React.createElement("div", {
    className: "nav__cta"
  }, cta), /*#__PURE__*/React.createElement("button", {
    className: 'burger' + (open ? ' open' : ''),
    "aria-label": "Menu",
    "aria-expanded": open,
    onClick: () => setOpen(!open)
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)))), open && /*#__PURE__*/React.createElement("nav", {
    style: {
      position: 'fixed',
      inset: '96px 0 0 0',
      zIndex: 99,
      background: 'var(--cream)',
      padding: '34px var(--gutter)',
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }
  }, links.map((l, i) => /*#__PURE__*/React.createElement("a", {
    key: i,
    href: l.href,
    style: {
      color: 'var(--navy)',
      fontSize: 28,
      fontWeight: 700,
      padding: '14px 0',
      borderBottom: '1px solid var(--navy-line)'
    },
    onClick: () => setOpen(false)
  }, l.label))));
}
Object.assign(__ds_scope, { NavBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/NavBar.jsx", error: String((e && e.message) || e) }); }

__ds_ns.DoseCard = __ds_scope.DoseCard;

__ds_ns.FamilyCard = __ds_scope.FamilyCard;

__ds_ns.MetaCard = __ds_scope.MetaCard;

__ds_ns.ProductCard = __ds_scope.ProductCard;

__ds_ns.StatCard = __ds_scope.StatCard;

__ds_ns.TipCard = __ds_scope.TipCard;

__ds_ns.ValueCard = __ds_scope.ValueCard;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Chip = __ds_scope.Chip;

__ds_ns.Eyebrow = __ds_scope.Eyebrow;

__ds_ns.StatBig = __ds_scope.StatBig;

__ds_ns.Timeline = __ds_scope.Timeline;

__ds_ns.IndicBanner = __ds_scope.IndicBanner;

__ds_ns.Footer = __ds_scope.Footer;

__ds_ns.ReassuranceBar = __ds_scope.ReassuranceBar;

__ds_ns.Accordion = __ds_scope.Accordion;

__ds_ns.NavBar = __ds_scope.NavBar;

})();
